import { Component, EventEmitter, HostBinding, Input, Output, TemplateRef } from '@angular/core';
import { DEFAULT_EMPTY_STATE, Option } from '@cumlaude/shared-utils';
import { CheckboxComponent } from '../checkbox/checkbox.component';
import { CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { NgTemplateOutlet } from '@angular/common';
import { isMeatballClick } from '@cumlaude/shared-utils';

@Component({
	selector: 'app-multi-select-checkbox',
	templateUrl: './multi-select-checkbox.component.html',
	styleUrls: ['./multi-select-checkbox.component.scss'],
	imports: [CdkVirtualScrollViewport, CdkFixedSizeVirtualScroll, CdkVirtualForOf, CheckboxComponent, NgTemplateOutlet],
})
export class MultiSelectCheckboxComponent<T> {
	@Input()
	options!: Option<T>[];

	@Input()
	value!: Option<T>[];

	@Input()
	legenda!: boolean;

	@Input()
	minimum = 0;

	@Input()
	blockedHover?: string;

	@HostBinding('class.in-dropdown')
	@Input()
	inDropdown = false;

	@Input()
	showEmpty: string = DEFAULT_EMPTY_STATE;

	@Output()
	valueChange = new EventEmitter<Option<T>[]>();

	@Input()
	menuTemplate?: TemplateRef<{ option: Option<T> }>;

	onSelected(option: Option<T>, $event: Event) {
		if (this.isBlocked(option)) return;
		if (isMeatballClick($event)) return;

		if (this.value.includes(option)) this.value = this.value.filter((opt) => opt != option);
		else this.value = [...this.value, option];

		this.valueChange.emit(this.value);
	}

	isSelected(option: Option<T>): boolean {
		return this.value.includes(option);
	}

	isBlocked(option: Option<T>): boolean {
		return this.value.length <= this.minimum && this.isSelected(option);
	}

	isHeader(option: Option<T>) {
		return option.style?.includes('header');
	}
}
